import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";

/**
 * Link helper that accepts a plain string path and routes dynamic guide
 * URLs (/resources/<slug>) through the typed `$slug` route.
 */
export function SiteLink({
  path,
  className,
  onClick,
  children,
}: {
  path: string;
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}) {
  if (path.startsWith("/resources/")) {
    return (
      <Link
        to="/resources/$slug"
        params={{ slug: path.slice("/resources/".length) }}
        className={className}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }
  return (
    <Link to={path as "/"} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
